module.exports = __webpack_public_path__ + "img/icon.5774b87e.png";